module.exports = __webpack_public_path__ + "Icono_AsignarATQ_512.png";